import * as React from 'react';
import { IBrandingState } from '../../../../services/branding/models';
import { Alert, Button, Modal as BootstrapModal } from 'react-bootstrap';
import { IPolicyApplication } from '../../../../data/api/models';
import { IQuoteActions } from '../../../../services/quote/models';
import { each } from 'lodash';
import * as api from '../../../../data/api/api';
import axios from 'axios';

interface IProps {
  branding: IBrandingState;
  quote: IPolicyApplication;
  quoteActions: IQuoteActions;
  push: (route: string) => void;
  cardDetails: any;
}

interface IRepurchaseState {
  repurchaseState: RepurchaseState;
  error: string;
  submitting: boolean;
  showModal: boolean;
  transactionId?: string;
}

type RepurchaseState = '' | 'pay-by-card' | 'pay-by-account' | 'loading' | 'error';

const ModalHeader = BootstrapModal.Header;
const ModalTitle = BootstrapModal.Title;
const ModalBody = BootstrapModal.Body;

class RepurchaseComponent extends React.Component<IProps, IRepurchaseState> {

  constructor(props) {
    super(props);
    this.state = {
      repurchaseState: '',
      error: '',
      submitting: false,
      showModal: false,
      transactionId: null,
    };
  }

  componentWillMount() {
    if (process.env.BROWSER) {
      window.addEventListener('message', this.handleWindowMessage, { passive: true });
    }
  }

  public componentWillUnmount() {
    if (process.env.BROWSER) {
      window.removeEventListener('message', this.handleWindowMessage, { capture: false });
    }
  }

  private handleWindowMessage = (event: MessageEvent) => {
    // For Chrome, the origin property is in the event.originalEvent object.
    const origin = event.origin || event.originalEvent.origin;

    if (origin !== axios.defaults.baseURL && !api.isGlobalPayOrigin(origin)) {
      return
    }

    const data = event.data;
    if (!('policies' in data && 'status' in data)) {
      return;
    }

    if (data.status !== 'complete') {
      // Show an error?
      this.setState({ repurchaseState: 'error', error: data.message });

      this.closeModal();

      return;
    }

    this.closeModal();
    this.pollResult(data);

    return;
  }

  public setRepurchaseState = (val: RepurchaseState) => () => {
    this.setState({ repurchaseState: val });
  };

  private renderPaymentInProgress = () => {
    return (
      <Alert bsStyle={'warning'} style={{ color: '#337ab7', marginTop: 20 }}>
        Payment in progress... Please wait.
      </Alert>
    );
  };

  private renderPaymentError() {
    return (
      <Alert bsStyle={'warning'} style={{ color: '#337ab7', marginTop: 20 }}>
        ERROR: {this.state.error}
      </Alert>
    );
  }

  public renderRepurchase = (repurchaseState: RepurchaseState, branding: IBrandingState) => {
    if (branding.channel.key === 'salt-om-ls-b2c') {
      switch (repurchaseState) {
        case 'pay-by-card':
          return this.renderRepurchaseByCard();
        case 'pay-by-account':
          return this.renderRepurchaseByAccount();
        default:
          return this.renderRepurchaseSelect();
      }
    } else {
      return this.renderRepurchaseByCard();
    }
  };

  public renderRepurchaseSelect = () => {
    return (<>
      <div className={'repurchase-wrapper'}>
        <div className={'repurchase-container'}>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '25px' }}>
            <Button
              bsStyle="primary"
              type="button"
              onClick={this.setRepurchaseState('pay-by-card')}
            >
              Pay via Card
            </Button>
            <Button
              bsStyle="primary"
              type="button"
              onClick={this.setRepurchaseState('pay-by-account')}
            >
              Pay via Account
            </Button>
          </div>

        </div>
      </div>
    </>);
  };

  public renderRepurchaseByAccount = () => {
    const { submitting } = this.state;
    return (<>
      <div className={'repurchase-wrapper'}>
        <div className={'repurchase-container'}>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '25px' }}>
            <Button
              bsStyle="default"
              type="button"
              onClick={this.setRepurchaseState('')}
            >
              Cancel
            </Button>
            <Button
              bsStyle="primary"
              type="button"
              onClick={this.payByBrokerAccount}
              disabled={submitting}
            >
              Confirm and Pay
            </Button>
          </div>

        </div>
      </div>
    </>);
  };

  public renderRepurchaseByCard = () => {
    const year = (new Date().getFullYear());
    const yearList = [];
    const monthList = [];
    for (let i = 0; i < 10; i++) {
      yearList.push({ label: year + i, value: year + i });
    }
    for (let i = 1; i <= 12; i++) {
      const num = i < 10 ? '0' + `${i}` : i;
      monthList.push({ label: num, value: num });
    }
    const { submitting } = this.state;

    return (<>
      <div className={'repurchase-wrapper'}>
        <div className={'repurchase-container'}>

          {/* BUTTONS */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '25px' }}>
            <Button
              bsStyle="primary"
              type="button"
              onClick={this.payByCard}
              disabled={submitting}
            >
              Pay via Card
            </Button>
            <Button
              bsStyle="default"
              type="button"
              onClick={this.setRepurchaseState('')}
            >
              Cancel
            </Button>
          </div>

        </div>
      </div>

    </>);
  };

  private payByCard = () => {
    const { quote, cardDetails } = this.props;
    quote.card = cardDetails;
    quote.reuseCustomerAddress = true;
    this.setState({ submitting: true })
    this.pay(quote);
  };

  private payByBrokerAccount = () => {
    const { quote } = this.props;
    quote.payOnAccount = true;
    this.setState({ submitting: true })
    this.pay(quote);
  };

  private pay = (quote: IPolicyApplication) => {
    const { branding } = this.props;

    this.setState({ repurchaseState: 'loading' });
    const { quoteActions } = this.props;
    quote.purchaseChannel = branding.channel.key;
    api.updatePolicyApplication(quote, { calculate: true})
      .then(() => {
        quoteActions.purchase(quote)
          .then((response: any) => quote.payOnAccount && this.pollResult(response))
          .catch((error: any) => {
            if (!this.catchRedirectToProvider(error)) {
              this.onRequestError(error);
            }
          })
          .finally(() => this.setState({ submitting: false }));
      })
  };

  private pollResult = (response) => {
    const token = response?.policies?.[0]?.documents_poll_token;
    const { quoteActions, push } = this.props;
    const id = setInterval(() => {
      quoteActions.pollPolicyDocuments(token)
        .then((response: any) => {
          const isFinished = response?.documents && Object.keys(response.documents).length;
          if (isFinished) {
            clearInterval(id);
            push('/account/summary');
          }
        })
        .catch((error: any) => {
          this.onRequestError(error);
          clearInterval(id);
        });
    }, 2000);
  };

  private catchRedirectToProvider = (error: any) => {
    let isRedirect = false;

    each(error.response.data.errors, (e) => {
      if (e.id !== 'redirect-to-provider') {
        return;
      }

      this.openModal(e.data.transactionId);
      isRedirect = true;
    });

    return isRedirect;
  };

  public openModal = (transactionId: string) => {
    this.setState({
      showModal: true,
      transactionId,
    });
  }

  public closeModal = () => {
    this.setState({
      showModal: false,
    });
  }

  private renderPaymentModal = () => {
    return (
      <BootstrapModal
        show={true}
        onHide={this.closeModal}
        bsSize="large"
        keyboard={false}
        backdrop="static"
      >
        <ModalHeader closeButton={true}>
          <ModalTitle>Payment</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <iframe allow="payment" src={api.getPaymentUrl(this.state.transactionId)} className="payments-modal" />
        </ModalBody>
      </BootstrapModal>
    );
  }

  private onRequestError = (error) => {
    const data = error?.response?.data;
    const genericMessage = 'Oops, something went wrong. Please try again or try purchasing the quote through the Renew Policy button.';
    this.setState({ repurchaseState: 'error', error: data?.errors?.[0]?.detail || genericMessage });
  };

  private handleRender = () => {
    const { branding } = this.props;
    const { repurchaseState } = this.state;

    if (repurchaseState === 'loading') return this.renderPaymentInProgress();
    if (repurchaseState === 'error') return this.renderPaymentError();
    return (<>
      <div>
        {this.renderRepurchase(repurchaseState, branding)}
      </div>
    </>);
  };

  public render() {
    return (<>
      {this.state.showModal && this.renderPaymentModal()}
      {this.handleRender()}
    </>);
  }
}

export default RepurchaseComponent;
